// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"e7e4f69d","455":"f7c1365b","488":"26e50605","569":"cb7f7897","794":"05f94a57","825":"bfc4dd12"}[chunkId] + ".chunk.js";
};